import {Info, X} from "lucide-react";
import {useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";

import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert";
import {Button} from "@/components/ui/button";
import {
  clearSessionEndedLoginSearch,
  getSessionEndedCopy,
  SESSION_ENDED_PARAM,
  SESSION_ENDED_REASON_PARAM,
} from "@/src/modules/auth/lib/session-ended-copy";

export function SessionEndedBanner() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  const showBanner = params.get(SESSION_ENDED_PARAM) === "1" && !dismissed;
  const reason = params.get(SESSION_ENDED_REASON_PARAM);

  if (!showBanner) {
    return null;
  }

  const message = getSessionEndedCopy(reason);

  const onDismiss = () => {
    setDismissed(true);
    clearSessionEndedLoginSearch(navigate, params);
  };

  return (
    <Alert variant="warning" className="relative mb-4" aria-live="polite">
      <Info className="size-4" />
      <AlertTitle>Session ended</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className="absolute right-2 top-2"
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        <X className="size-4" />
      </Button>
    </Alert>
  );
}
